import React from 'react' // eslint-disable-line no-unused-vars
import { notify } from "reapop";
import Select from '../forms/Select'
import InputGroup from '../forms/InputGroup'
import { validateField, submitForm } from '../pages/functions'
import { connect } from 'react-redux'
import { REF_DATA, ABBVIE_EMPLOYEE, HCP } from '../constants'
import CountryAwareComponent from '../mi-app/CountryAwareComponent'
import StaticConfig from '../mi-app/StaticConfig'
import { CircularProgress } from '@material-ui/core'
import { formFieldsPerLanguage } from './language/FormFieldsPerLanguage'
import { api } from './index.api'
import { getApplicationRegex } from './plugins/utils';

class SearchForm extends CountryAwareComponent {
  constructor(props) {
    super(props)

    this.componentName = 'SearchForm'
    var fields = {
      product: {
        name: 'product',
        value: '',
        rules: { title: 'Product', required: { required: true } }
      },
      category: {
        name: 'category',
        value: '',
        rules: { title: 'Category', required: { required: true } }
      },
      keywords: {
        name: 'keywords',
        value: '',
        rules: { title: 'Keywords', required: { required: true } }
      }
    }

    this._mapReferencedataToFields(props)

    this.state = {
      fields,
      categoriesLoaded: false
    }

    formFieldsPerLanguage(this.state.fields, this.props.pageContent.content)

    this.searchCriteria = {}
    this._validate = this._validate.bind(this)
    this._submit = this._submit.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    formFieldsPerLanguage(this.state.fields, nextProps.pageContent.content)
    this._mapReferencedataToFields(nextProps)
    if (StaticConfig.Context.UserType === ABBVIE_EMPLOYEE) {
      const copyFields = this.state.fields
      copyFields.keywords.rules.required.required = false
      copyFields.keywords.rules.ignoreNull = true
      copyFields.category.rules.required.required = false
      copyFields.category.rules.ignoreNull = true
      this.setState({
        fields: copyFields
      })
    }
  }

  componentDidMount() { }

  // this updates the list of available categories to choose from
  // base on product selection
  handleProductChange = (product, _field) => {
    const { category } = { ...this.state.fields }
    category.value = ''
    this.setState({ categoriesLoaded: false })
    if (product) {
      api.searchCategories(
        {
          product,
          country:
            StaticConfig.Context.UserType === ABBVIE_EMPLOYEE
              ? StaticConfig.Context.ssoCountry.name
              : StaticConfig.Context.Country.name
        },
        response => {
          response.json().then(categories => {
            const categoryOptions = this._translateCategoryOptions(categories)
            this.setState({ categories: categoryOptions, categoriesLoaded: true })
          })
        },
        error => { /* eslint-disable-line */
          // handle error
        }
      )
    }
  }

  _translateCategoryOptions = categories => {
    if (!categories || !categories.length) {
      return []
    }

    return categories.map(category => ({
      value: category,
      label: this.props.pageContent.content.module.searchDocument.categories[category] || category
    })).sort((c1, c2) => c1.label.localeCompare(c2.label))
  }

  _mapReferencedataToFields = nextProps => {
    if (nextProps.referenceData.length > 0) {
      const refData = nextProps.referenceData.filter(function (item) {
        return item.type === REF_DATA
      })[0]

      if (refData) {
        let approverProducts = StaticConfig.Context.searchProductList
        if (StaticConfig.Context.UserType === HCP && approverProducts) {
          approverProducts = approverProducts.filter(function (product) {
            return product.availableToExternalForSearch === true;
          });
       } else if (
          StaticConfig.Context.UserType === ABBVIE_EMPLOYEE &&  approverProducts
        ) {
          approverProducts = approverProducts.filter(function (product) {
            return product.availableToEmployeeForSearch === true;
          });
        }
        this.products = approverProducts.map(function (product) {
          return {
            value: product.veevaProductCode,
            label: product.name
          }
        })
      }
    }
  }

  _init(formData) {
    // initial search calls the constructor again and resets state
    // so here, fields are reinitialized
    this.handleProductChange(formData.product)

    const copyFields = this.state.fields

    copyFields.product.value = formData.product
    copyFields.category.value = formData.category
    copyFields.keywords.value = formData.keywords

    this.setState({
      fields: copyFields
    })
  }

  _validateKeyword = (e, field) => {
    e.preventDefault()
    let modifiedEvent = { target: { value: e.target.value }, preventDefault: () => true }
    if (StaticConfig.Context.UserType !== ABBVIE_EMPLOYEE) {
      modifiedEvent.target.value = modifiedEvent.target.value.replace(/\*/g, '')
    }
    this._validate(modifiedEvent, field)
  }  

    _validate(e, field) {
      const inputValue = e.target.value.toLowerCase();
      const ref_Data = this.props.referenceData.find(function (item) {
        return item.type === REF_DATA
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);
      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        this.props._showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (regex.Script_Regex !== null && regex.Script_Regex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        this.props._showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        this.props._showNotification(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
        var fields = validateField(e, field, this.state.fields);
        this.setState({ fields })
        return false
      }

  _submit(e) {
    if (StaticConfig.Context.UserType === ABBVIE_EMPLOYEE) {
      const copyFields = this.state.fields
      copyFields.keywords.rules.required.required = false
      copyFields.keywords.rules.ignoreNull = true
      copyFields.category.rules.required.required = false
      copyFields.category.rules.ignoreNull = true
      this.setState({
        fields: copyFields
      })
    }

    const fields = submitForm(e, this.state.fields)

    this.setState({ fields })

    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        return false
      }
    }
    this.props.submit({
      product: this.state.fields.product.value,
      category: this.state.fields.category.value,
      keywords: this.state.fields.keywords.value,
      country:
        StaticConfig.Context.UserType === ABBVIE_EMPLOYEE
          ? StaticConfig.Context.ssoCountry.name
          : StaticConfig.Context.Country.name,
      searchUserType: StaticConfig.Context.UserType,
      type: null
    })
  }

  isSearchButtonDisabled = () => {
    return !this.state.fields.product.value ||
      this.props.isSearching ||
      (this.state.fields.category.rules.required.required !== false &&
        !this.state.fields.category.value) ||
      (this.state.fields.keywords.rules.required.required !== false &&
        !this.state.fields.keywords.value)
  }

  render() {
    const languageContent = this.props.pageContent.content

    if (this.props.parentMethod) this.props.parentMethod()
    const jsx = (
      <form
        onSubmit={e => {
          e.preventDefault()
          this._submit(e)
        }}
      >
        <div className='row search-form'>
          <div className='col-xl-12'>
            <div className='row'>
              <div className='col-lg-10'>
                <p
                  className='text-left subtitle'
                >{languageContent.module.searchDocument.helperText}
                </p>
              </div>
              <div className='col-lg-2'>
                <p className='text-right subtitle required-indic'>
                  <strong>*{languageContent.module.searchDocument.required}</strong>
                </p>
              </div>
            </div>
          </div>
          <div className='col-lg-4 col-xl-4'>
            <Select
              id='productSearch'
              searchable
              clearable
              options={this.products}
              field={this.state.fields.product}
              validate={(e, field) =>
                this._validate(e, this.state.fields.product)}
              onChange={this.handleProductChange}
            />
          </div>
          <div
            id='category'
            className='col-lg-4 col-xl-4 mt-2 mt-lg-0 category-search'>
            <Select
              labelStyle={
                !this.state.categoriesLoaded ? 'category-search-label' : null
              }
              searchable
              clearable
              options={this.state.categories}
              field={this.state.fields.category}
              validate={(e, field) =>
                this._validate(e, this.state.fields.category)}
              disabled={!this.state.categoriesLoaded}
            />
          </div>
          <div className='col-lg-4 col-xl-4 mt-2 mt-lg-0'>
            <InputGroup
              field={this.state.fields.keywords}
              validate={(e, field) =>
                this._validateKeyword(e, this.state.fields.keywords)}
            />
          </div>
          <div className='col-xl-1 mt-4 m-b-10 text-left'>
            <button
              id='searchDocuments'
              type='submit'
              className={`btn ${!this.isSearchButtonDisabled() ? 'btn-info' : 'btn-info-no-hover'} btn-lg-wide submit-button btn-rounded`}
              disabled={this.isSearchButtonDisabled()}
            >
              {
                this.props.isSearching
                  ? <div className='loading-text-centered'>
                    <span>{languageContent.module.searchDocument.search}</span>
                    <span className='loading-progress-centered'><CircularProgress size={24} /></span>
                  </div>
                  : <React.Fragment>{languageContent.module.searchDocument.search}</React.Fragment>
              }
            </button>
          </div>
        </div>
      </form>
    )
    return this.countriesMatched() ? jsx : null
  }
}

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent,
    permissions: state.permissions,
    notify: { notify }
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  SearchForm
)



// WEBPACK FOOTER //
// ./src/mi-app/SearchForm.js